"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_TestReport_Participant = exports.TestReport_ParticipantTypeKind = void 0;
var t = __importStar(require("io-ts"));
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_uri_1 = require("../Scalar/RTTI_uri");
var TestReport_ParticipantTypeKind;
(function (TestReport_ParticipantTypeKind) {
    TestReport_ParticipantTypeKind["_testEngine"] = "test-engine";
    TestReport_ParticipantTypeKind["_client"] = "client";
    TestReport_ParticipantTypeKind["_server"] = "server";
})(TestReport_ParticipantTypeKind = exports.TestReport_ParticipantTypeKind || (exports.TestReport_ParticipantTypeKind = {}));
var EnumType_1 = require("../../EnumType");
exports.RTTI_TestReport_Participant = t.recursion('ITestReport_Participant', function () {
    return t.partial({
        id: t.string,
        extension: t.array(RTTI_Extension_1.RTTI_Extension),
        modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
        type: (0, EnumType_1.createEnumType)(TestReport_ParticipantTypeKind, 'TestReport_ParticipantTypeKind'),
        _type: RTTI_Element_1.RTTI_Element,
        uri: RTTI_uri_1.RTTI_uri,
        _uri: RTTI_Element_1.RTTI_Element,
        display: t.string,
        _display: RTTI_Element_1.RTTI_Element
    });
});
//# sourceMappingURL=RTTI_TestReport_Participant.js.map